import MarketHeroStats from '../token/MarketHeroStats'
import TokenDetails from '../token/TokenDetails'
import { useState } from 'react'
import TokenInfo from '../token/TokenInfo'
import TokenDistribution from '../token/TokenDistribution'
import TradesHoldersTabs from '../token/TradesHoldersTabs'
import { EnterBottomExitBottom } from '../shared/Transitions'
import SwapSettings from '../swap/SwapSettings'
import dynamic from 'next/dynamic'
import TradesFeedSocketProvider from '@components/trade/TradesFeedSocketProvider'
import Orderbook from '@components/orderbook/Orderbook'
import UserTabs from '@components/token/UserTabs'
import TradeTabs from '@components/trade/TradeTabs'

const TradingViewChart = dynamic(
  () => import('@components/trade/TradingViewChart'),
  { ssr: false },
)

const MobileTokenPage = () => {
  const [showSlippageSettings, setShowSlippageSettings] = useState(false)

  return (
    <TradesFeedSocketProvider>
      <TokenInfo />
      <div className={`shared-container mb-3 flex h-[320px] flex-col`}>
        <div className="flex-1 p-4">
          <TradingViewChart />
        </div>
      </div>
      <div className={`shared-container mb-3 p-4`}>
        <MarketHeroStats />
      </div>
      <div className="relative">
        <div className={`shared-container grid h-full grid-cols-2 pb-6`}>
          <EnterBottomExitBottom
            className="thin-scroll absolute bottom-0 left-0 z-20 col-span-2 size-full overflow-auto rounded-3xl bg-th-bkg-1 p-6 pb-0"
            show={showSlippageSettings}
          >
            <SwapSettings onClose={() => setShowSlippageSettings(false)} />
          </EnterBottomExitBottom>
          <div className={`col-span-2 sm:col-span-1`}>
            <TradeTabs />
          </div>
          <div
            className={`col-span-2 h-[520px] border-t border-th-bkg-3 sm:col-span-1 sm:border-t-0 sm:pt-[17px]`}
          >
            <Orderbook />
          </div>
        </div>
      </div>
      <div className="mt-3 space-y-3">
        <UserTabs />
        <TradesHoldersTabs />
        <TokenDetails />
        <TokenDistribution />
      </div>
    </TradesFeedSocketProvider>
  )
}

export default MobileTokenPage
